import React from "react";

interface TickIconProps {
  size?: number | string;
  className?: string;
  onClick?: () => void;
  color?: string;
}

const LogoutIcon: React.FC<TickIconProps> = ({
  size = 22,
  className,
  onClick,
  color = "currentColor"
}) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41602 6.29965C7.67435 3.29965 9.21602 2.07465 12.591 2.07465H12.6993C16.4243 2.07465 17.916 3.56631 17.916 7.29131V12.7246C17.916 16.4496 16.4243 17.9413 12.6993 17.9413H12.591C9.24102 17.9413 7.69935 16.733 7.42435 13.783" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.5009 10H3.01758" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.87565 7.20831L2.08398 9.99998L4.87565 12.7916" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default LogoutIcon;
